<div class="w-3/4 mx-auto">
  <mat-toolbar>
    <span class="order-2 w-full text-center">使用者註冊</span>
  </mat-toolbar>


  @if(showSignUpForm){

    <form [formGroup]="form" #signupForm="ngForm" (ngSubmit)="onSignUp()" novalidate>
      <mat-form-field >
        <mat-label>代號</mat-label>
        <input matInput type="text" formControlName="name">
          <button matSuffix mat-icon-button aria-label="Clear" (click)="form.setValue({name: 'test'})">
            <mat-icon>close</mat-icon>
          </button>
      </mat-form-field>

      <mat-form-field  lines="none" >
        <input matInput  type="text" formControlName="username" placeholder="姓名">
        <input>
      </mat-form-field >

      <mat-form-field  lines="none" >
        <input matInput  type="email" formControlName="email" placeholder="EMAIL"><input>
      </mat-form-field >

        <p>
          <small> Email is optional but is needed for password resets in case you forget your password.</small>
        </p>

      <mat-form-field  lines="none" >
        <input matInput  [type]="!showPass ? 'password' : 'text' " formControlName="password" placeholder="密碼">
        <input>
        @if (!showPass) {
        <button mat-flat-button fill="clear" color="dark" type="button" slot="end"
          (click)="this.showPass = !this.showPass;">
          <mat-icon name="eye-off"></mat-icon>
        </button>
        }
        @if (showPass) {
        <button mat-flat-button fill="clear" color="dark" type="button" slot="end"
          (click)="this.showPass = !this.showPass;">
          <mat-icon name="eye"></mat-icon>
        </button>
        }
      </mat-form-field >
        <p>
          <small>密碼長度不夠</small>
        </p>
      <p>
          <button mat-flat-button strong type="submit" color="primary" expand="block" shape="round"
            [disabled]="isSignUpLoading" (click)="registUser($event)">
            @if (isSignUpLoading) {
            <mat-progress-spinner
            [mode]="spinnerMode"
            [value]="spinnerValue">
        </mat-progress-spinner>
            }
            @if (!isSignUpLoading) {
            <span>註冊...</span>
            }
          </button>
      </p>
      <p>
        <button mat-flat-button style="text-transform: none;" strong type="button" fill="clear" expand="block" color="dark" shape="round"
        (click)="onLoginButtonTouched()">
        回登入畫面
      </button>

      </p>
    </form>
  }
</div>
